import { Model } from 'dva';
import { validateField } from '../validators';
import { childrenStepCompleted } from '../selectors/children';

const stepInitialState = {
  error: '',
  isCompleted: false
};

const initialState = {
  children: stepInitialState
};

const steps: Model = {
  namespace: 'steps',
  state: initialState,
  reducers: {
    'set/error'(state, { payload }) {
      const { type, error } = payload;
      state[type].isCompleted = false;
      state[type].error = error;
      return state;
    },
    'unset/error'(state, { payload }) {
      state[payload].error = '';
      return state;
    },
    'set/completed'(state, { payload }) {
      state[payload].isCompleted = true;
      state[payload].error = '';
      return state;
    }
  },
  effects: {
    *'check/error'({ payload }, { select, put }) {
      const { type, validatorName } = payload;
      const state = yield select(state => state);
      const result = validateField(`${type}/${validatorName}`, state);

      if (!result[validatorName].error) {
        yield put({ type: 'unset/error', payload: 'children' });
      }
    },
    *validate({ payload }, { select, put }) {
      const isCompleted = yield select(childrenStepCompleted);
      if (isCompleted) {
        yield put({ type: 'set/completed', payload });
      }
    }
  }
};

export default steps;
